import React, { JSX } from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, ITProps, spacing, Text, TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const activeColor = publicaColors.blue;
const inactiveColor = publicaColors.lightGray;

interface IProps {
  className?: string;
  disabled?: boolean;
  iconSlug: string;
  onClick: () => void;
  tKey: TKey;
  tProps?: ITProps;
}

export const IconTextButtonV2 = ({
  className,
  disabled,
  iconSlug,
  onClick,
  tKey,
  tProps = {},
}: IProps): JSX.Element => {
  return (
    <button
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        backgroundColor: 'inherit',
        borderWidth: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-block',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        lineHeight: 'inherit',
        margin: 0,
        padding: 0,
        whiteSpace: 'nowrap',
      }}
    >
      <Cols smallHorizontalPadding gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
        <Col displayFlex>
          <IconV2 name={iconSlug} small color={disabled ? inactiveColor : activeColor} />
        </Col>
        <Col>
          <Text
            bold
            color={disabled ? inactiveColor : activeColor}
            singleLineLabel
            small
            tKey={tKey}
            tProps={tProps}
          />
        </Col>
      </Cols>
    </button>
  );
};
